import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TabSwitcher.scss';

export default class TabSwitcher extends Component {
    static propTypes = {
        tabs: PropTypes.array.isRequired,
        renderTab: PropTypes.func.isRequired
    }

    static defaultProps = {
        renderTab: (tab, i) => null
    }

    onSetHeatId = (externalId) => {
        const { onSetHeatId } = this.props;

        onSetHeatId(externalId);
    }

    render() {
        const {
            tabs,
            renderTab
        } = this.props;

        return (
            <div className="tab-switcher">
                {tabs.map((tab, i) => {
                    return renderTab(tab, i);
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/base/TabSwitcher.js